module.exports = __webpack_public_path__ + "static/media/partner-icon-nftcdn-white.5e6ce654.svg";